export const APPLE_SEARCH_PREFIX = 'maps://maps.apple.com/?q='
export const GOOGLE_SEARCH_PREFIX = 'https://www.google.com/maps/search/'

const HOWS_MY_DRIVING_NY_API_DOMAIN = 'https://api.howsmydrivingny.nyc'

export const HOWS_MY_DRIVING_NY_NEW_LOOKUP_ENDPOINT = `${HOWS_MY_DRIVING_NY_API_DOMAIN}/api/v1/`
export const HOWS_MY_DRIVING_NY_PREVIOUS_LOOKUP_ENDPOINT = `${HOWS_MY_DRIVING_NY_API_DOMAIN}/api/v1/lookup/`
